import { useMemo } from 'react'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { useUserContext } from '../../../Contexts/UserConfig'

export function useResultsReportCols() {
  const { loginConfig } = useUserContext()
  return useMemo(() => {
    return [
      {
        flex: 1,
        headerName: 'Screen ID',
        field: 'ScreenID',
      },
      {
        flex: 1,
        headerName: 'Recipient Lab',
        field: 'DestinationFacilityID',
        valueFormatter: (value: any) =>
          getCodeSetLabelLookup(loginConfig, ['KV-Facilities'], value),
      },
      {
        flex: 1,
        headerName: 'Parent Vessel ID',
        field: 'ParentVesselID',
      },
      {
        flex: 1,
        headerName: 'Sample ID',
        field: 'SampleID',
      },
      {
        flex: 2,
        headerName: 'Sample Type',
        field: 'SampleType',
        valueFormatter: (value: any) =>
          getCodeSetLabelLookup(loginConfig, ['SampleRunTypeID'], value),
      },
      {
        flex: 2,
        headerName: 'Tests',
        field: 'Tests',
      },
      {
        flex: 1,
        headerName: 'Result',
        field: 'Result',
        valueFormatter: (value: any) =>
          getCodeSetLabelLookup(loginConfig, ['ResultID'], value),
      },
      {
        flex: 2,
        headerName: 'Results Entered',
        field: 'SampleResultDate',
      },
      {
        flex: 1,
        headerName: 'Holding',
        field: 'OriginHoldingID',
        valueFormatter: (value: string | number | undefined) =>
          getCodeSetLabelLookup(loginConfig, ['KV-Holdings'], value),
      },
      {
        flex: 1,
        headerName: 'Rack ID',
        field: 'RackID',
      },
      {
        flex: 1,
        headerName: 'Animal ID',
        field: 'AnimalID',
      },
      {
        flex: 2,
        headerName: 'Short Line Name',
        field: 'ShortLineName',
      },
    ]
  }, [loginConfig])
}
